
import BaseSvg from "@/components/base/BaseSvg.vue";
import DepartureTicketType from "@/components/bookingflow/steps/departure/DepartureTicketType.vue";
import { getDurationInMinutes, HHmm, EEEddM } from "@/helpers/dateHelper";
import { DirectionEnum, TicketTypeEnum } from "@/models/enums";
import { TicketTypeState } from "@/models/www/store/BookingState";
import { DeparturePrice } from "@/models/www/DeparturePrice";
import { useBookingStore } from "@/store/booking";
import { computed, defineComponent, PropType, ref } from "vue";
import useDayTrip from "@/composables/useDayTrip";

export default defineComponent({
	components: {
		BaseSvg,
		DepartureTicketType,
	},
	props: {
		departure: {
			type: Object as PropType<DeparturePrice>,
			required: true,
		},
		direction: {
			type: Number as PropType<DirectionEnum>,
			required: true,
		},
		selected: Boolean,
		modelValue: String,
	},
	setup(props, { emit }) {
	
		const displayFlexi = ref<boolean>(false);
		const { isDayTrip, openDayTripConfirmationDialog } = useDayTrip();
		const { getDeparture, setDepartureTicketType } = useBookingStore();

		const displayAlternatives = computed(() => {
			return props.departure.hasFlexi && !isDayTrip.value && props.selected;
		});

		const selectDeparture = () => {
			if (props.departure?.ticketTypes && !isDayTrip.value) {
				displayFlexi.value = true;
			}

			if (isDayTrip.value && props.direction === DirectionEnum.Return) {
				openDayTripConfirmationDialog(() => {
					emit("update:modelValue", props.departure.departureId);
				});
			} else {
				emit("update:modelValue", props.departure.departureId);
			}
		};

		const ticketTypeInput = computed({
			get(): string {
				return getDeparture(props.direction)?.ticketType?.id;
			},
			set(value: string) {
				const ticketType = props.departure.ticketTypes?.find(
					(x) => x.id === value
				);

				if (ticketType) {
					setDepartureTicketType(props.direction, {
						identifier: ticketType.identifier,
						type: ticketType.type,
						id: ticketType.id,
					} as TicketTypeState);
				}
			},
		});

		return {
			HHmm,
			getDurationInMinutes,
			selectDeparture,
			ticketTypeInput,
			displayFlexi,
			TicketTypeEnum,
			isDayTrip,
			displayAlternatives,
		};
	},
});
